import { jsx as c, Fragment as i, jsxs as l } from "@emotion/react/jsx-runtime";
import { css as C } from "@emotion/react";
import { desktopFirstMediaQuery as b } from "@inflearn/ds-react-next";
import { u as e, aR as n, B as a } from "./StickyHeaderSkeleton-812aba96.mjs";
import "react";
import "react/jsx-runtime";
import "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import "dayjs/locale/vi";
import "dayjs/locale/ja";
import "dayjs/plugin/localizedFormat";
import "dayjs/plugin/timezone";
import "dayjs/plugin/updateLocale";
import "dayjs/plugin/utc";
import "@inflearn/analytics";
import "@tanstack/react-query";
import "@inflearn/datasource-rest";
const I = 157, t = `${a}/assets/channeltalk/channeltalk.png?w=${I * 2}`;
function L() {
  const {
    t: g
  } = e();
  return /* @__PURE__ */ c(i, { children: /* @__PURE__ */ c("a", { href: n, target: "_blank", className: "channel-talk__redirect-button", css: o, rel: "noreferrer", children: /* @__PURE__ */ l("picture", { children: [
    /* @__PURE__ */ c("source", { srcSet: `${t}&f=avif`, type: "image/avif" }),
    /* @__PURE__ */ c("source", { srcSet: `${t}&f=webp`, type: "image/webp" }),
    /* @__PURE__ */ c("img", { src: t, alt: g("채널톡 아이콘") })
  ] }) }) });
}
const o = /* @__PURE__ */ C({
  position: "fixed",
  zIndex: 9999,
  bottom: "50px",
  right: "18px",
  display: "flex",
  flexWrap: "nowrap",
  WebkitBoxAlign: "center",
  alignItems: "center",
  WebkitBoxPack: "center",
  justifyContent: "center",
  width: `${I}px`,
  height: "74px",
  [b.tablet]: {
    display: "none"
  },
  picture: {
    width: "100%",
    height: "100%"
  },
  img: {
    width: "100%",
    height: "100%"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleButton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
export {
  L as ChannelTalk
};
